import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { useState, useEffect, useRef } from "react";
import {
  getAggregatedData,
  getAggregatedDataWrapper,
  onFilterModelChange,
  renderGrid,
  aggregatedAdministrativeTableColumns,
} from "./AgroAnalyticsUtils";

const aggregatedMacroSpecieTableColumns = () => [
  {
    field: "Anno",
    headerName: i18n.t("agriculture.year"),
    width: 60,
  },

  {
    field: "Compagnia",
    headerName: i18n.t("company"),
    width: 60,
  },

  {
    field: "Macrospecie",
    headerName: "Macrospecie",
    width: 120,
  },
  {
    field: "Specie_Group",
    headerName: "Specie Group",
    width: 120,
  },
  ...aggregatedAdministrativeTableColumns(),
];

export const AgroMacroSpecieGrid = ({ filterModel, wantedReferenceDateProp }) => {
  const { t } = useTranslation();

  const [aggregatedMacroSpecieTableState, setAggregatedMacroSpecieTableState] = useState({
    isLoading: false,
    total: 0,
  });

  const aggregatedMacroSpecieCancelTokenRef = useRef(null);

  const [aggregatedMacroSpecieTableData, setAggregatedMacroSpecieTableData] = useState([]);

  useEffect(() => {
    const getAggregatedMacroSpecieData = async () => {
      return await getAggregatedData(
        setAggregatedMacroSpecieTableState,
        setAggregatedMacroSpecieTableData,
        { aggr: "Macrospecie" },
        filterModel,
        wantedReferenceDateProp,
        aggregatedMacroSpecieCancelTokenRef,
      );
    };
    const getAggregatedMacroSpecieDataWrapper = async () => {
      getAggregatedDataWrapper(aggregatedMacroSpecieCancelTokenRef, getAggregatedMacroSpecieData);
    };

    onFilterModelChange(filterModel, getAggregatedMacroSpecieDataWrapper);
  }, [filterModel, wantedReferenceDateProp]);

  return renderGrid(
    aggregatedMacroSpecieTableColumns(),
    aggregatedMacroSpecieTableData,
    aggregatedMacroSpecieTableState,
    t,
    "Agenzie",
  );
};
